import { useDispatch, useSelector } from "react-redux";
import {
  segwayInfoState,
  segwayInfoError,
  segwayInfoLoading,
  segwayInfoUpdatedTime,
  fetchAsyncSegwayInfo,
} from "../segwayInfo/SegwayInfoSlice";
import { PortInfoStatus, fetchAsyncPortInfo } from "../portInfo/PortInfoSlice";

import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { useState, useEffect, useRef } from "react";
import Marker from "./Marker";

const MapDesc = () => {
  //API通信
  const dispatch = useDispatch();

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncSegwayInfo());
    dispatch(fetchAsyncPortInfo());

    const interval = setInterval(() => {
      dispatch(fetchAsyncSegwayInfo());
      dispatch(fetchAsyncPortInfo());
    }, 15000); //15秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch]); // 依存配列にdispatchを含める

  //データにアクセス
  const mapSegwayData = useSelector(segwayInfoState);
  const mapPortData = useSelector(PortInfoStatus);
  const updatedTime = useSelector(segwayInfoUpdatedTime);

  //map
  const [map, setMap] = useState<google.maps.Map>();
  const ref = useRef<HTMLDivElement>();

  useEffect(() => {
    //マップ描画部分

    if (ref.current && !map) {
      const map = new window.google.maps.Map(ref.current, {
        center: {
          lat: 35.1692477,
          lng: 136.8973835,
        },
        zoom: 15,
        styles: [
          {
            stylers: [{ saturation: -80 }],
          },
        ],
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
      });
      setMap(map);
    }
  }, [map]);

  const [showMarkers, setShowMarkers] = useState(false); // マーカー表示状態の管理

  const toggleMarkers = () => {
    setShowMarkers(!showMarkers);
  };

  return (
    <>
      <button onClick={toggleMarkers}>ポートを表示</button>
      <div className="time_msg">※データは15秒ごとに自動更新されます</div>
      <div>最終更新時間 : {updatedTime}</div>
      <div ref={ref as any} style={{ height: "100%", width: "100%" }}>
        <Marker
          map={map!}
          segway={mapSegwayData}
          port={mapPortData}
          showMarkers={showMarkers}></Marker>
      </div>
    </>
  );
};

export default MapDesc;
